import { createContext, useContext, useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { SITE_IMAGES } from "@/lib/data";

const ContentContext = createContext(null);
const BLANK = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const DEFAULTS = Object.fromEntries(SITE_IMAGES.map((s) => [s.key, s.def]));

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = () =>
    api.get("/content").then((res) => setContent(res.data)).catch(() => setContent({}));

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);

export const useSiteImage = () => {
  const { content } = useContent();
  return (key) => {
    if (!content) return BLANK;
    const custom = content.images?.[key];
    return custom ? mediaUrl(custom) : DEFAULTS[key];
  };
};
